import Login from './Login';
import Logout from './Logout';
import EnterDrawTicket from './EnterDrawTicket';
import GetEntries from './GetEntries';
import GetPlayerData from './GetPlayerData';
import Update from '../FauxAPI/Update';
import Register from '../FauxAPI/Register';
import Winners from '../FauxAPI/Winners';
import PostFeedback from '../FauxAPI/PostFeedback';
import ForgotPassword from '../FauxAPI/ForgotPassword';
import GetGame from '../FauxAPI/GetGame';
import GetGameOver from '../FauxAPI/GetGameOver';
import SetEntryFlashGameFlag from './SetEntryFlashGameFlag';

export default {
    login: Login,
    update: Update,
    logout: Logout,
    enterDrawTicket: EnterDrawTicket,
    getEntries: GetEntries,
    getPlayerData: GetPlayerData,
    register: Register,
    winners: Winners,
    postFeedback: PostFeedback,
    forgotPassword: ForgotPassword,
    getGame: GetGame,
    getGameOver: GetGameOver,
    setEntryFlashGameFlag: SetEntryFlashGameFlag,
};
